import { render, staticRenderFns } from "./ReviewDetails.vue?vue&type=template&id=1b2c5748&scoped=true"
import script from "./ReviewDetails.vue?vue&type=script&lang=js"
export * from "./ReviewDetails.vue?vue&type=script&lang=js"
import style0 from "./ReviewDetails.vue?vue&type=style&index=0&id=1b2c5748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2c5748",
  null
  
)

export default component.exports